export const UNO_URL = "https://api.simulanis.io";
// export const UNO_URL = 'https://abmcpl-ar-vr-appsvcbackend.azurewebsites.net';
// export const UNO_URL = 'http://localhost:3003';
// export const UNO_URL = 'https://metaverse.hpcl.co.in:3003';
// export const UNO_URL = 'https://simulanis-uno-backend-backup-uat.azurewebsites.net';

export const applicationId = "ea4e622a-9aa8-42de-83c7-0a469c9d9f49";
export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
